module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"developed_by":"developed by","formater_uri":"https://en.poleterresolide.fr"},"fr":{"developed_by":"développé par","formater_uri":"https://www.poleterresolide.fr"}}')
  delete Component.options._Ctor
}
